import React, { useState } from "react";
import { containerVariants } from "../signup/motion";
import { motion } from "framer-motion";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Step1 = ({ setStep, setTempToken }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/api/user/forgotPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to send verification code");
      }
      
      setTempToken(data.body.token)     
      setStep(2);
    } catch (err) {
      // console.log(err)
      setError(err.message || "An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      key="email"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="bg-white py-8 px-10 rounded-sm shadow-custom border border-[#2A3D66]/40 w-full max-w-xl"
    >
      <h2 className="text-2xl mb-2">Forgot Password?</h2>
      <p className="text-gray-600 mb-6">
        Don't worry, we'll help you access your account
      </p>
      <form onSubmit={handleEmailSubmit}>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1">
              Email address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-2.5 py-1.5 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border-[#BBBBBB] bg-[#F0F0F0] text-sm"
              required
            />
          </div>
          <div className="w-full flex items-center justify-center">
            {loading ? (
              <button
                className="w-[172px] h-[40px] bg-[#036494] rounded-full flex items-center justify-center"
                disabled
              >
                <span className="loader"></span>
              </button>
            ) : (
              <button
                type="submit"
                className="w-max px-6 bg-[#036494] text-white py-2 rounded-full hover:bg-[#025177] transition-colors font-light"
              >
                Reset Password
              </button>
            )}
          </div>
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}
        </div>
      </form>
    </motion.div>
  );
};

export default Step1;
